import { render, staticRenderFns } from "./Retur.vue?vue&type=template&id=528896a2&scoped=true"
import script from "./Retur.vue?vue&type=script&lang=js"
export * from "./Retur.vue?vue&type=script&lang=js"
import style0 from "./Retur.vue?vue&type=style&index=0&id=528896a2&prod&scoped=true&lang=css"
import style1 from "./Retur.vue?vue&type=style&index=1&id=528896a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528896a2",
  null
  
)

export default component.exports